/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgUnitReserveListPathOrgUnitId, OrgUnitReserveListStatus200 } from "../types/OrgUnitReserveList.ts";

function getOrgUnitReserveListUrl(org_unit_id: OrgUnitReserveListPathOrgUnitId) {
	const res = { method: "GET", url: `/api/org_unit/${org_unit_id}/reserve/` as const };

	return res;
}

/**
 * @summary список броней гостя на точке
 * {@link /api/org_unit/:org_unit_id/reserve/}
 */
export async function orgUnitReserveList(org_unit_id: OrgUnitReserveListPathOrgUnitId, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitReserveListStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgUnitReserveListUrl(org_unit_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
